/**
 * @generated SignedSource<<fbdeb79565959637d7e45870912ffd14>>
 * @relayHash 40ddeb0ef9f72faff15ea2ef539798b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81

import type { ConcreteRequest } from 'relay-runtime';
export type useFeedTypeSelectorRefreshQuery$variables = Record<PropertyKey, never>;
export type useFeedTypeSelectorRefreshQuery$data = {
  readonly userPreferences: {
    readonly __typename: "UserPreferences";
    readonly feedTab: string | null;
  } | null;
};
export type useFeedTypeSelectorRefreshQuery = {
  response: useFeedTypeSelectorRefreshQuery$data;
  variables: useFeedTypeSelectorRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "ScalarField",
        "name": "feedTab"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useFeedTypeSelectorRefreshQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useFeedTypeSelectorRefreshQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "40ddeb0ef9f72faff15ea2ef539798b5",
    "id": "1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81",
    "metadata": {},
    "name": "useFeedTypeSelectorRefreshQuery",
    "operationKind": "query",
    "text": "query useFeedTypeSelectorRefreshQuery{userPreferences{__typename,feedTab}}"
  }
};
})();

(node as any).hash = "6ca55df8184dd78031693e2b650f878d";

export default node;
